<template>
    <div>
        <div>
            <div class="tw-upload-images" v-for="(item, index) in imgArray" :key="index">
                <Image imageClass="tw-image tw-upload-img" imageStyle="background: var(--surface-b);" :src="item[field_name]" :preview="true"/>
                
                <i class="pi pi-times p-button-danger tw-upload-icon" @click="deleteImg(item)"></i>
            </div>
        </div>
        <FileUpload :mode="mode" name="demo[]" :url="url" :multiple="multiple" :disabled="readonly" :auto="auto" :accept="accept" :maxFileSize="maxFileSize * 1000" :fileLimit="fileLimit" 
            :customUpload="customUpload" invalidFileSizeMessage="{0}: 文件大小应小于 {1}" invalidFileLimitMessage="超出了最大文件数，限制最多为 {0}" 
            @before-upload="beforeUpload" @before-send="beforeSend" @upload="upload" @error="error" @clear="clear" @select="select" @progress="progress" @uploader="uploader" @remove="remove">
            <template #empty>
                <p>将文件拖放到此处上传</p>
            </template>
        </FileUpload>
    </div>
</template>

<script>
import { computed } from 'vue'
import FileUpload from 'primevue/fileupload';
import Image from 'primevue/image';

export default {
    name: 'tw-upload',
    components: {
        FileUpload,
        Image
    },
    setup(props, context) {
        const imgArray = computed(() => {
            if (props.data_source && props.field_name) {
                // 可能是数据源对象，也可能是插槽传过来的对象
                if (props.data_source?.datas && Array.isArray(props.data_source?.datas)) {
                    return props.data_source?.datas ?? []
                }else{
                    return []
                }
            } else {
                return []
            }
        })

        const deleteImg = (item) => {
            context.emit('delete-img', item)
        }

        const beforeUpload = (event) => {
            context.emit('before-upload', event)
        }

        const beforeSend = (event) => {
            context.emit('before-send', event)
        }

        const upload = (event) => {
            context.emit('upload', event)
        }

        const error = (event) => {
            context.emit('error', event)
        }

        const clear = () => {
            context.emit('clear')
        }

        const select = (event) => {
            context.emit('select', event)
        }

        const progress = (event) => {
            context.emit('progress', event)
        }

        const uploader = (event) => {
            context.emit('uploader', event)
        }

        const remove = (event) => {
            context.emit('remove', event)
        }

        return {
            deleteImg,
            beforeUpload,
            beforeSend,
            upload,
            error,
            clear,
            select,
            progress,
            uploader,
            remove,
            imgArray
        }
    },
    props: {
        data_source: {
            type: Object,
            default: function() {
                return { }
            }
        },
        field_name: {
            type: String,
            default: ''
        },
        url: String,
        mode: String,
        multiple: Boolean,
        accept: String,
        readonly: {
            type: Boolean,
            default: false
        },
        auto: Boolean,
        maxFileSize: Number,
        fileLimit: Number,
        customUpload: Boolean
    }
}

</script>